<template>
  <div class="comp_help_money">
    <Popup  v-model="show" position="bottom"  @close="onClose" class="hh_sheet"  >
      <div class="help_wrap">
        <div class="lw_div" v-if="tab_active==0">
          <div class="hh_con">
            <div class="hh_money">
              <div class="hh_item" @click="moneyClick(50,10)">
                <p class="piao">助力10票</p>
                <p class="money"><img src="@/assets/img/live/mydou.png" />50</p>
              </div>
              <div class="hh_item" @click="moneyClick(400,88)">
                <p class="piao">助力88票</p>
                <p class="money"><img src="@/assets/img/live/mydou.png" />400</p>
              </div>
              <div class="hh_item" @click="moneyClick(1500,388)">
                <p class="piao">助力388票</p>
                <p class="money"><img src="@/assets/img/live/mydou.png" />1500</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gift_bottom">
        <div class="gifttab_nav">
          <div class="gift_nav_item" :class="{is_active:tab_active==0}">助力</div>
          <!-- <div class="gift_nav_item">任务</div> -->
        </div>
        <div class="gift_bottom_right">
          <div class="remain_btn" @click="goToBalance">余额<img src="@/assets/img/live/mydou.png" />{{BanlanceCount(balance)}}<i class="iconfont icon-xiala"></i></div>
        </div>
      </div>
    </Popup>
     <van-dialog id="van-dialog" class="yue_dialog" />
  </div>
</template>

<script>
import { Popup, Dialog } from "vant";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  // 热榜
  name: "comp-help-money",
  props:{
    isLive:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return { 
      show: false,           //是否显示火热助力
      tab_active:0,
      balance:0,    //余额
    };
  },
  components: {Popup},
  computed: {
    ...mapGetters({
      roomInfo: "getRoomInfo",
      userInfo: "getUserInfo",
    }),
    query() {
      return this.$router.history.current.query;
    },
  },
  created(){
    this.balance=this.userInfo.balance;
  },
  mounted(){
    this.$Bus.$off('helpClick');
    this.$Bus.$on('helpClick',()=>{
      this.helpOpen()
    })
  },
  methods: {
    ...mapActions({
      LinkToMyAccount:'linkTo/LinkToMyAccount',
      LinkToMyService:'linkTo/LinkToMyService'
    }),
    // 人数超过w换算
    BanlanceCount(value) { //过万处理
        var num=value;
        if (value > 9999) { //大于9999显示x.xx万
            num = (Math.floor(value / 100) / 100) + 'w';
        } else if (value <= 9999 && value > -9999) {
            num = value
        } else if (value < -9999) { //小于-9999显示-x.xx万
            num = -(Math.floor(Math.abs(value) / 1000) / 10) + 'w'
        }
        return num;
    },
    ...mapActions({
      // helpMoney: "ex/helpMoney",
      // getExaminePay:"ex/getExaminePay",
      helpMyDou:'act/helpMyDou',
      getBanlance: "act/getBanlance",
    }),
    onClose(){
      this.show=false;
    },
    goToBalance(){
      this.LinkToMyAccount('expend')
    },
    yebuzu(){
      Dialog.confirm({
        title: '余额不足',
        message: '您的金豆余额不足了，请前往\n联系客服',
        className:'dialog_yue',
        zIndex:99999,
        confirmButtonText:'前往',
        confirmButtonOpenType:'contact',
      })
      .then(() => { 
        this.LinkToMyService();
        // on confirm
      })
      .catch(() => {
        this.$toast.fail("助力失败");
        // on cancel
      });
    },
    moneyClick(money,piao){
      let content='';
      if(this.isLive){
        content=this.roomInfo.title;
      }
      if(this.balance>=money){
        Dialog.confirm({
            title: '助力 '+piao+' 票',
          message: content,
          className:'zuli',
          zIndex:10005,
          confirmButtonText:'确定',
          })
          .then(() => {
            let opt={
              inMemberId: this.userInfo.inMember.id,
              amount:money,
              helpType: 1,
              typeId:this.query.actId,
              title: "活动助力"+piao+"票",
              number: 1,
            }
            this.gotoHlpe(opt);
          })
          .catch(() => {  
            this.$toast.fail("取消助力"); 
          });
      }else{
        this.yebuzu();
      }
    },
    async gotoHlpe(opt){
      // console.log(opt,'opt');
      let res= await this.helpMyDou(opt);
      if(res.result){
        this.$toast.success("助力成功");
        this.$Bus.$emit('moneyOk');
        this.onClose();
      }else{
        this.$toast.fail("助力失败");
      }
    },
    async helpOpen(){
      let res=await this.getBanlance(this.userInfo.id);
      if(res){
        this.balance=res;
      }
      this.show=true;
    }
  }
};
</script>

<style scoped lang="scss">
.comp_help_money{
   .hh_sheet{
    background:#fff;
    z-index:2000!important;
    padding:0.3rem 0 0;
    border-radius: 0.2rem 0.2rem 0 0;
    ::v-deep .help_wrap{
      .lw_div{
        padding: 0 0.2rem;
        box-sizing: border-box;
        .hh_con{
          // border-top: 1px solid #4d4d4d;
          .hh_money{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .hh_item{
              width: 2.2rem;
              border-radius: 0.03rem;
              overflow: hidden;
              border:1px solid #f85b0f;
              box-sizing: border-box;
              background: #fff;
              text-align: center;
              color: #fff;
              p{
                font-size: 0.26rem;
                display: flex;
                justify-content: center;
                align-items: center;
                &.piao{
                  background: #f85b0f;
                  height: 0.69rem;
                }
                &.money{
                  height: 0.5rem;
                  color:#f85b0f;
                  img{
                    display: block;
                    width: 0.26rem;
                    height: .26rem;
                    margin-right: .1rem;
                  }
                }
              }
            }
          }
        }
      }
      
    }
    .gift_bottom{
      margin-top: .2rem;
      height:1rem;
      box-sizing: border-box;
      border-top: 1px solid #f5f5f5;
      padding: 0 .2rem;
      display: flex;
      justify-content:space-between;
      .gifttab_nav{
        display: flex;
        align-items: center;
        height: 100%;
        font-size: .26rem;
        .gift_nav_item{
          display: flex;
          align-items: center;
          color: #999;
          height: 100%;
          margin-right: .5rem;
          &:last-child{
            margin-right: 0;
          }
          &.is_active{
            color: #333;
            position: relative;
            &::before{
              content: '';
              position: absolute;
              display: block;
              width: .5rem;
              height:0.04rem;
              background-color: #f85b0f;
              border-radius: 1px;
              left: 50%;
              transform: translateX(-50%);
              bottom:.23rem;
            }
          }
        }
      }
      .gift_bottom_right{
        
        display: flex;
        height: 100%;
        align-items: center;
        .remain_btn{
          padding:0 0.13rem;
          height: 0.58rem;
          box-sizing: border-box;
          color: #666;
          font-size: .22rem;
          display: flex;
          border-radius:0.1rem;
          background: rgba(248,91,15,0.1);
          align-items: center;   
          img{
            width:0.26rem;
            height: 0.26rem;
            display: block;
            margin:0 0.1rem;
          }
          .iconfont{
            color: #999;
            margin-left: 0.15rem;
            transform: rotate(-90deg) translateY(1px);
          }
        }
      }
    }
  }
  ::v-deep .van-overlay{
    z-index: 1800!important;
  }
   ::v-deep .yue_dialog{
    .van-popup{
      border-radius: 0.1rem;
      width: 5.6rem;
      box-sizing: border-box;
      .van-dialog__header{
        padding-top: 0.5rem;
        font-size: .36rem;
        font-weight: bold;
        color: #333;
      }
      .van-dialog__message{
        font-size: .3rem;
        color: #666;
      }
      .van-hairline--top{
        &::after{
          border-color:#d2d3d5;
          border-top-width: 0.02rem;
        }
      }
      .van-dialog__footer{
        .van-hairline--right{
          &::after{
            border-color: #d2d3d5;
            border-right-width: 0.02rem;

          }
        }
        .van-dialog__button{
          .dialog-index--van-dialog__confirm{
            color: #f85b0f!important;
          }
        }
      }
    }
  }
}
</style>
